import React, { useState, useEffect } from "react";
import { Field, Switch, Input, Textarea, Text, Dropdown, Option } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import "../../CSS/IaAgent.css";

export default function KnowledgeBaseTab({ agentData, updateField }) {
  const { t } = useTranslation();
  const kb = agentData.knowledgeBase || {};

  // JSON editor for the `data` array (future: proper Q&A editor)
  const [jsonText, setJsonText] = useState("");
  const [jsonError, setJsonError] = useState("");

  useEffect(() => {
    try {
      setJsonText(JSON.stringify(kb.data || [], null, 2));
      setJsonError("");
    } catch {
      setJsonText("[]");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agentData.id]);

  const onJsonChange = (value) => {
    setJsonText(value);
    try {
      const parsed = JSON.parse(value || "[]");
      updateField("knowledgeBase.data", parsed);
      setJsonError("");
    } catch (e) {
      setJsonError(e.message);
    }
  };

  return (
    <div className="ia-agent-tab">
      <Switch
        label={t("KB_ENABLED")}
        checked={!!kb.enabled}
        onChange={(_, d) => updateField("knowledgeBase.enabled", d.checked)}
      />

      {kb.enabled && (
        <>
          <Field label={t("KB_NAME")} className="field-style" style={{ marginTop: 12 }}>
            <Input value={kb.name || ""} onChange={(_, d) => updateField("knowledgeBase.name", d.value)} />
          </Field>

          <Field label={t("KB_LANGUAGE")} className="field-style">
            <Dropdown
              value={kb.language || "en"}
              selectedOptions={[kb.language || "en"]}
              onOptionSelect={(_, d) => updateField("knowledgeBase.language", d.optionValue)}
            >
              <Option value="en" text="English">English</Option>
              <Option value="fr" text="French">French</Option>
            </Dropdown>
          </Field>

          <Field label={t("KB_USAGE_INSTRUCTIONS")} className="field-style">
            <Textarea
              value={kb.usageInstructions || ""}
              onChange={(_, d) => updateField("knowledgeBase.usageInstructions", d.value)}
              placeholder={t("KB_USAGE_INSTRUCTIONS_PLACEHOLDER")}
              rows={3}
              resize="vertical"
            />
          </Field>

          <Field label={t("KB_FALLBACK_MESSAGE")} className="field-style">
            <Textarea
              value={kb.fallbackMessage || ""}
              onChange={(_, d) => updateField("knowledgeBase.fallbackMessage", d.value)}
              placeholder={t("KB_FALLBACK_MESSAGE_PLACEHOLDER")}
              rows={2}
              resize="vertical"
            />
          </Field>

          <Field
            label={t("KB_DATA_JSON")}
            className="field-style"
            validationState={jsonError ? "error" : "none"}
            validationMessage={jsonError || t("KB_DATA_JSON_HINT")}
          >
            <Textarea
              value={jsonText}
              onChange={(_, d) => onJsonChange(d.value)}
              placeholder='[ { "question": "...", "answer": "..." } ]'
              rows={12}
              resize="vertical"
              style={{ fontFamily: "monospace" }}
            />
          </Field>

          <Text className="ia-agent-hint">{t("KB_TAB_HINT")}</Text>
        </>
      )}
    </div>
  );
}
